import type { LoginResponse } from '@ferty9/types';
import { authHeaders, jsonInit, requestJson } from './client';

export interface LoginPayload {
  username: string;
  password: string;
}

export function login(payload: LoginPayload): Promise<LoginResponse> {
  return requestJson<LoginResponse>('/api/auth/login', jsonInit('POST', payload));
}

export function getCurrentUser(token?: string): Promise<Pick<LoginResponse, 'user'>> {
  return requestJson<Pick<LoginResponse, 'user'>>('/api/auth/me', {
    headers: authHeaders(token),
  });
}

export function logout(token?: string): Promise<{ success: boolean }> {
  return requestJson<{ success: boolean }>('/api/auth/logout', { ...jsonInit('POST', {}, token), keepalive: true });
}

export type RecoveryChannel = 'email' | 'whatsapp';
export interface RecoveryMethod { channel: RecoveryChannel; maskedDestination: string }
export function beginPasswordRecovery(identifier: string) { return requestJson<{ success: true; challengeToken: string; methods: RecoveryMethod[]; message: string }>('/api/auth/password-recovery/begin', jsonInit('POST', { identifier })); }
export function sendPasswordRecoveryOtp(challengeToken: string, channel: RecoveryChannel) { return requestJson<{ success: true; message: string }>('/api/auth/password-recovery/send-otp', jsonInit('POST', { challengeToken, channel })); }
export function completePasswordRecovery(payload: { challengeToken: string; channel: RecoveryChannel; otp: string; newPassword: string; confirmPassword: string }) { return requestJson<{ success: true; message: string }>('/api/auth/password-recovery/complete', jsonInit('POST', payload)); }
